import api from './api';

export const billingService = {
  async getCreditPacks() {
    const response = await api.get('/billing/credit-packs');
    return response.data;
  },

  // How many Founding 50 spots are still open. Drives the hype banner +
  // counter on the landing pricing section. Returns { remaining, total, available }.
  async getFoundingSpots() {
    const response = await api.get('/billing/founding-spots');
    return response.data;
  },

  async getSubscriptionPlans() {
    const response = await api.get('/billing/subscription-plans');
    return response.data;
  },

  async checkoutCredits(data) {
    const response = await api.post('/billing/checkout/credits', data);
    return response.data;
  },

  async checkoutSubscription(data) {
    const response = await api.post('/billing/checkout/subscription', data);
    return response.data;
  },

  async cancelSubscription() {
    const response = await api.post('/billing/cancel-subscription');
    return response.data;
  },

  async getBillingPortal(returnUrl) {
    const response = await api.get('/billing/portal', { params: { returnUrl } });
    return response.data;
  },
};

export default billingService;
